import * as React from 'react';
import {PropsWithChildren} from "react";

export interface INestedMenuProps extends PropsWithChildren {
    /** Open state */
    open?: boolean;
    /** Inform parent */
    setHasOpenSubMenu?: (val) => void;
    setOpenSubMenu?: (val) => void;
    /** ID */
    id?: string;
    children?: React.ReactNode;
}

const NestedMenu: React.FunctionComponent<INestedMenuProps> = (props) => {
    return (
        <ul className="nested-menu">
            {React.Children.map(props.children, (child, index) => {
                if (typeof child === 'string' || typeof child === 'number' || child === null) {
                    return child;
                } else {
                    if (React.isValidElement(child)) {
                        if (typeof child.type === 'function') {
                            const id = 'menuitem-' + index;
                            const extendedProps = {
                                open: props.open,
                                id,
                                setOpenSubMenu: props.setOpenSubMenu,
                            };
                            return React.cloneElement(child, extendedProps);
                        } else {
                            return child;
                        }
                    }
                    return null;
                }
            })}
        </ul>
    );
};

NestedMenu.displayName = 'NestedMenu';

export default NestedMenu;
